/* eslint no-magic-numbers: 0 */

export enum Amazon {
  siteIdCTPDesktop = 'desktop_ctp',
  siteIdAutoplayDesktop = 'desktop_autoplay',
  siteIdCTPMobile = 'mobile_ctp',
  siteIdAutoplayMobile = 'mobile_autoplay'
}

export enum IndexExchangeVideo {
  bidAdjustment = 0.7,
  id = 'indexExchange',
  siteIdOutstreamDesktop = 502649,
  siteIdOutstreamMobile = 502650,
  siteIdAutoplayDesktop = 341818,
  siteIdAutoplayMobile = 341820,
  siteIdCTPDesktop = 341819,
  siteIdCTPMobile = 341821,
  testSiteId = 199990,
  timeout = 1000
}

export enum Pubmatic {
  adSlotOutstreamDesktop = 'desktop_outstream',
  adSlotOutstreamMobile = 'mobile_outstream',
  adSlotAdhesion = 'adhesion_video',
  adSlotDesktop = 'desktop_video',
  adSlotMobile = 'mobile_video',
  adSlotSticky = 'sticky_video',
  id = 'pubmatic',
  publisherId = '157108',
  testAdSlot = 'test_video',
  testPublisherId = '157593'
}
